// src/pages/help/topics/strategyHub.js
// Guide « Strategy Hub ». Contenu validé — toute modification se fait ici.
export const fr = {
  title: "Strategy Hub",
  tagline: "Construire et évaluer ta stratégie de trading",
  readMin: 6,
  intro:
    "Le Strategy Hub est un constructeur de stratégie intégré à FullMetrix. Il permet au trader de structurer clairement sa méthode de trading en regroupant, au même endroit, toutes les informations importantes qui définissent sa stratégie.",
  brief: [
    "Créer une stratégie et organiser ses règles au même endroit",
    "Lancer une Analyse IA : score, niveau, points forts et manques",
    "Modifier, relancer l'analyse et conserver plusieurs stratégies",
  ],
  steps: [
    {
      title: "Créer la stratégie",
      text: "Nom, type de trading, marchés, actifs favoris et unités de temps utilisées.",
    },
    {
      title: "Renseigner les règles",
      text: "Règles d'entrée, règles de sortie, conditions d'annulation, Take Profit, Stop Loss et Break-even.",
    },
    {
      title: "Définir la gestion du risque",
      text: "Type de money management et risque utilisé par trade.",
    },
    {
      title: "Lancer l'Analyse IA",
      text: "Le système attribue un score global, un niveau, une note par pilier, et liste points positifs, éléments incomplets, risques et améliorations possibles.",
    },
    {
      title: "Corriger puis relancer",
      text: "Modifie les éléments signalés et relance une analyse pour comparer les résultats.",
    },
  ],
  tips: [
    "Plus les informations sont précises, plus l'évaluation est pertinente : une stratégie incomplète donne une analyse limitée.",
    "Un bon score signifie que la stratégie est bien structurée dans les informations fournies — pas qu'elle sera rentable sur le marché.",
    "Le Strategy Hub ne remplace ni le backtest, ni la pratique, ni la gestion du risque.",
  ],
  faq: [
    {
      q: "Qu'est-ce que le Strategy Hub ?",
      a:
        "Le Strategy Hub est un constructeur de stratégie intégré à FullMetrix.\n\n" +
        "Il permet au trader de structurer clairement sa méthode de trading en regroupant, au même endroit, toutes les informations importantes qui définissent sa stratégie.",
    },
    {
      q: "À quoi sert le Strategy Hub ?",
      a:
        "Le Strategy Hub permet notamment de :\n" +
        "• créer une stratégie de trading\n" +
        "• organiser ses règles de manière claire\n" +
        "• identifier les éléments manquants\n" +
        "• évaluer la qualité globale de la stratégie\n" +
        "• recevoir des suggestions d'amélioration\n" +
        "• conserver plusieurs stratégies dans une bibliothèque\n\n" +
        "L'objectif est d'aider le trader à mieux comprendre la manière dont sa stratégie est construite.",
    },
    {
      q: "Quelles informations peut-on renseigner ?",
      a:
        "L'utilisateur peut notamment définir :\n" +
        "• le nom de la stratégie\n" +
        "• le type de trading\n" +
        "• les marchés concernés\n" +
        "• les actifs favoris\n" +
        "• les unités de temps utilisées\n" +
        "• les règles d'entrée\n" +
        "• les règles de sortie\n" +
        "• les conditions d'annulation\n" +
        "• le Take Profit\n" +
        "• le Stop Loss\n" +
        "• le Break-even\n" +
        "• le type de money management\n" +
        "• le risque utilisé par trade\n\n" +
        "Plus les informations sont précises, plus l'évaluation de la stratégie peut être pertinente.",
    },
    {
      q: "Comment fonctionne l'Analyse IA ?",
      a:
        "Une fois les informations renseignées, l'utilisateur peut lancer une Analyse IA.\n\n" +
        "Le système étudie la structure de la stratégie et attribue notamment :\n" +
        "• un score global\n" +
        "• un niveau d'évaluation\n" +
        "• une note sur différents piliers\n" +
        "• les points positifs\n" +
        "• les éléments incomplets\n" +
        "• les risques identifiés\n" +
        "• les améliorations possibles",
    },
    {
      q: "Quels éléments peuvent être évalués ?",
      a:
        "Selon les informations fournies, l'Analyse IA peut notamment examiner :\n" +
        "• la clarté des règles\n" +
        "• l'utilisation des timeframes\n" +
        "• la qualité des conditions d'entrée\n" +
        "• les règles de sortie\n" +
        "• la gestion du risque\n" +
        "• le money management\n" +
        "• la cohérence du Stop Loss et du Take Profit\n" +
        "• la précision des conditions d'annulation\n\n" +
        "Chaque partie peut recevoir une évaluation distincte afin d'aider le trader à repérer plus facilement les points faibles.",
    },
    {
      q: "Que signifient le score et le niveau ?",
      a:
        "Le score permet d'avoir une indication générale sur la qualité et la structure de la stratégie renseignée.\n\n" +
        "Le niveau permet de classer cette évaluation de manière plus simple.\n\n" +
        "Un bon score signifie que la stratégie est globalement bien structurée dans les informations fournies.\n\n" +
        "Cependant, cela ne signifie pas qu'elle sera automatiquement rentable sur le marché.",
    },
    {
      q: "Que peut recommander l'Analyse IA ?",
      a:
        "L'Analyse IA peut suggérer au trader de :\n" +
        "• préciser certaines règles\n" +
        "• mieux définir ses conditions d'entrée\n" +
        "• clarifier ses sorties\n" +
        "• ajouter des conditions d'annulation\n" +
        "• améliorer sa gestion du risque\n" +
        "• revoir son money management\n" +
        "• compléter certains timeframes\n" +
        "• mieux encadrer l'utilisation du Break-even\n" +
        "• conserver les éléments déjà bien définis\n\n" +
        "L'objectif est de montrer clairement ce qui doit être amélioré, complété ou conservé.",
    },
    {
      q: "Le Strategy Hub vérifie-t-il la rentabilité réelle de la stratégie ?",
      a:
        "Non.\n\n" +
        "Le Strategy Hub évalue principalement la qualité de la structure et la cohérence des informations renseignées.\n\n" +
        "Il ne peut pas garantir :\n" +
        "• que la stratégie sera rentable\n" +
        "• qu'elle fonctionnera dans toutes les conditions de marché\n" +
        "• qu'elle produira les mêmes résultats sur tous les actifs\n" +
        "• qu'elle remplacera un backtest ou une période de pratique réelle\n\n" +
        "Pour évaluer les performances réelles d'une stratégie, il reste nécessaire de la tester.",
    },
    {
      q: "Peut-on modifier une stratégie après son analyse ?",
      a:
        "Oui.\n\n" +
        "Après avoir reçu l'évaluation, l'utilisateur peut modifier les différents éléments de sa stratégie puis relancer une nouvelle analyse.\n\n" +
        "Cela permet de comparer les résultats et de voir si les changements apportés améliorent la structure générale.",
    },
    {
      q: "Peut-on enregistrer plusieurs stratégies ?",
      a:
        "Oui.\n\n" +
        "L'utilisateur peut créer et conserver plusieurs stratégies dans sa bibliothèque.\n\n" +
        "Il peut ensuite :\n" +
        "• les consulter\n" +
        "• les modifier\n" +
        "• les analyser de nouveau\n" +
        "• les ajouter aux favoris\n" +
        "• les comparer\n" +
        "• supprimer celles qu'il n'utilise plus",
    },
    {
      q: "L'Analyse IA remplace-t-elle le travail du trader ?",
      a:
        "Non.\n\n" +
        "Les suggestions générées servent d'aide à la réflexion.\n\n" +
        "Le trader doit toujours :\n" +
        "• vérifier la pertinence des recommandations\n" +
        "• tenir compte de son expérience\n" +
        "• tester sa stratégie\n" +
        "• adapter les règles à son marché\n" +
        "• décider lui-même des modifications à appliquer\n\n" +
        "Le Strategy Hub aide à mieux structurer une stratégie, mais ne remplace ni le backtest, ni la pratique, ni la gestion du risque.",
    },
    {
      q: "Comment obtenir une analyse plus pertinente ?",
      a:
        "Pour obtenir une évaluation plus utile, il est conseillé de :\n" +
        "• remplir toutes les sections\n" +
        "• éviter les règles trop vagues\n" +
        "• préciser les conditions d'entrée et de sortie\n" +
        "• expliquer clairement les exceptions\n" +
        "• définir le risque par trade\n" +
        "• décrire correctement le money management\n" +
        "• indiquer les marchés et unités de temps réellement utilisés\n\n" +
        "Une stratégie incomplète ou imprécise donnera naturellement une analyse plus limitée.",
    },
    {
      q: "Comment contacter le support ?",
      a:
        "Pour obtenir une réponse plus rapide, nous recommandons de contacter le support FullMargin par WhatsApp.\n\n" +
        "Lors de la demande, il est conseillé d'envoyer :\n" +
        "• l'adresse e-mail du compte FullMargin\n" +
        "• le nom de la stratégie concernée\n" +
        "• une description du problème\n" +
        "• une capture de la page\n" +
        "• une capture du résultat de l'Analyse IA, si nécessaire",
    },
  ],
  related: ["graphiques-backtest", "journal-auto", "challenges"],
};

export const en = {
  title: "Strategy Hub",
  tagline: "Build and evaluate your trading strategy",
  readMin: 6,
  intro:
    "The Strategy Hub is a strategy builder integrated into FullMetrix. It lets the trader structure their trading method clearly by gathering, in one place, all the important information that defines their strategy.",
  brief: [
    "Create a strategy and organise its rules in one place",
    "Run an AI Analysis: score, level, strengths and gaps",
    "Edit, re-run the analysis and keep several strategies",
  ],
  steps: [
    { title: "Create the strategy", text: "Name, trading type, markets, favourite assets and timeframes used." },
    {
      title: "Fill in the rules",
      text: "Entry rules, exit rules, invalidation conditions, Take Profit, Stop Loss and Break-even.",
    },
    { title: "Define risk management", text: "Money management type and risk used per trade." },
    {
      title: "Run the AI Analysis",
      text: "The system gives an overall score, a level, a rating per pillar, and lists strengths, incomplete items, identified risks and possible improvements.",
    },
    { title: "Fix, then re-run", text: "Edit the flagged items and run the analysis again to compare results." },
  ],
  tips: [
    "The more precise the information, the more relevant the review: an incomplete strategy gets a limited analysis.",
    "A good score means the strategy is well structured in the information provided — not that it will be profitable.",
    "The Strategy Hub replaces neither backtesting, nor practice, nor risk management.",
  ],
  faq: [
    {
      q: "What is the Strategy Hub?",
      a:
        "The Strategy Hub is a strategy builder integrated into FullMetrix.\n\n" +
        "It lets the trader structure their trading method clearly by gathering, in one place, all the important information that defines their strategy.",
    },
    {
      q: "What is the Strategy Hub for?",
      a:
        "The Strategy Hub lets you:\n" +
        "• create a trading strategy\n" +
        "• organise your rules clearly\n" +
        "• identify missing elements\n" +
        "• evaluate the overall quality of the strategy\n" +
        "• receive improvement suggestions\n" +
        "• keep several strategies in a library\n\n" +
        "The goal is to help the trader better understand how their strategy is built.",
    },
    {
      q: "What information can I fill in?",
      a:
        "You can define:\n" +
        "• the strategy name\n" +
        "• the trading type\n" +
        "• the markets involved\n" +
        "• favourite assets\n" +
        "• the timeframes used\n" +
        "• entry rules\n" +
        "• exit rules\n" +
        "• invalidation conditions\n" +
        "• Take Profit\n" +
        "• Stop Loss\n" +
        "• Break-even\n" +
        "• the money management type\n" +
        "• the risk used per trade\n\n" +
        "The more precise the information, the more relevant the evaluation.",
    },
    {
      q: "How does the AI Analysis work?",
      a:
        "Once the information is filled in, you can run an AI Analysis.\n\n" +
        "The system studies the structure of the strategy and returns:\n" +
        "• an overall score\n" +
        "• an evaluation level\n" +
        "• a rating on different pillars\n" +
        "• the strengths\n" +
        "• the incomplete items\n" +
        "• the risks identified\n" +
        "• possible improvements",
    },
    {
      q: "What can be evaluated?",
      a:
        "Depending on the information provided, the AI Analysis can examine:\n" +
        "• the clarity of the rules\n" +
        "• the use of timeframes\n" +
        "• the quality of entry conditions\n" +
        "• exit rules\n" +
        "• risk management\n" +
        "• money management\n" +
        "• the consistency of Stop Loss and Take Profit\n" +
        "• the precision of invalidation conditions\n\n" +
        "Each part can get its own rating so weak spots are easier to find.",
    },
    {
      q: "What do the score and level mean?",
      a:
        "The score gives a general indication of the quality and structure of the strategy as described.\n\n" +
        "The level classifies that evaluation more simply.\n\n" +
        "A good score means the strategy is broadly well structured in the information provided.\n\n" +
        "It does not mean it will automatically be profitable on the market.",
    },
    {
      q: "What can the AI Analysis recommend?",
      a:
        "The AI Analysis can suggest that you:\n" +
        "• make some rules more precise\n" +
        "• better define your entry conditions\n" +
        "• clarify your exits\n" +
        "• add invalidation conditions\n" +
        "• improve your risk management\n" +
        "• revisit your money management\n" +
        "• complete some timeframes\n" +
        "• frame the use of Break-even better\n" +
        "• keep the parts already well defined\n\n" +
        "The goal is to show clearly what should be improved, completed or kept.",
    },
    {
      q: "Does the Strategy Hub check the real profitability of the strategy?",
      a:
        "No.\n\n" +
        "The Strategy Hub mainly evaluates the quality of the structure and the consistency of the information provided.\n\n" +
        "It cannot guarantee:\n" +
        "• that the strategy will be profitable\n" +
        "• that it will work in all market conditions\n" +
        "• that it will produce the same results on every asset\n" +
        "• that it replaces a backtest or real practice\n\n" +
        "To evaluate real performance, the strategy still has to be tested.",
    },
    {
      q: "Can I edit a strategy after its analysis?",
      a:
        "Yes.\n\n" +
        "After receiving the evaluation, you can edit the different parts of your strategy and run a new analysis.\n\n" +
        "This lets you compare results and see whether your changes improve the overall structure.",
    },
    {
      q: "Can I save several strategies?",
      a:
        "Yes.\n\n" +
        "You can create and keep several strategies in your library.\n\n" +
        "You can then:\n" +
        "• review them\n" +
        "• edit them\n" +
        "• analyse them again\n" +
        "• add them to favourites\n" +
        "• compare them\n" +
        "• delete the ones you no longer use",
    },
    {
      q: "Does the AI Analysis replace the trader's work?",
      a:
        "No.\n\n" +
        "The generated suggestions are food for thought.\n\n" +
        "The trader must always:\n" +
        "• check how relevant the recommendations are\n" +
        "• take their experience into account\n" +
        "• test the strategy\n" +
        "• adapt the rules to their market\n" +
        "• decide themselves which changes to apply\n\n" +
        "The Strategy Hub helps structure a strategy, but replaces neither backtesting, nor practice, nor risk management.",
    },
    {
      q: "How do I get a more relevant analysis?",
      a:
        "For a more useful evaluation:\n" +
        "• fill in every section\n" +
        "• avoid rules that are too vague\n" +
        "• be precise about entry and exit conditions\n" +
        "• explain the exceptions clearly\n" +
        "• define the risk per trade\n" +
        "• describe money management properly\n" +
        "• state the markets and timeframes you actually use\n\n" +
        "An incomplete or imprecise strategy will naturally get a more limited analysis.",
    },
    {
      q: "How do I contact support?",
      a:
        "For a faster answer, we recommend contacting FullMargin support on WhatsApp.\n\n" +
        "With your request, send:\n" +
        "• the email address of your FullMargin account\n" +
        "• the name of the strategy involved\n" +
        "• a description of the problem\n" +
        "• a screenshot of the page\n" +
        "• a screenshot of the AI Analysis result, if needed",
    },
  ],
  related: ["graphiques-backtest", "journal-auto", "challenges"],
};
